
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq8eeS5a4yzdoZ8AzjCyoBVqTSuS6Xnff1b_45kpjoQdZiUMeta } from "/codebuild/output/src797466349/src/src/pages/faq.vue?macro=true";
import { default as menuHBflX3pewFZ8_IASfF2CKIFv8J_45ZNA5Bq1XGiazjd0QMeta } from "/codebuild/output/src797466349/src/src/pages/menu.vue?macro=true";
import { default as indexl1mVl8I7wryahIvd76XxuJCq_458XY_SWiVebgF6H3DGQMeta } from "/codebuild/output/src797466349/src/src/pages/index.vue?macro=true";
import { default as contactvvtPUd9fG9gRuyxgTk_45UDM_uZAUkUVTJKl3XymvN0oIMeta } from "/codebuild/output/src797466349/src/src/pages/contact.vue?macro=true";
import { default as tutorialTOeChTVmAB4Gde0_IY_45nlNOzq_rte2jhkcRXI8EZxsAMeta } from "/codebuild/output/src797466349/src/src/pages/tutorial.vue?macro=true";
import { default as agreementR0Y0v5pPoT1juk7jLIH_45J9GfJ7V53AnAME8DfmqfYNcMeta } from "/codebuild/output/src797466349/src/src/pages/agreement.vue?macro=true";
import { default as about_45passWFtDgvUUJv2svSO5cl_45vtccHAuXnQYjOw6pqmRXkk1cMeta } from "/codebuild/output/src797466349/src/src/pages/about-pass.vue?macro=true";
import { default as indexYnS3SYHT9bNKuFG4GRpqWEI7wrH0NylyUxSobJmo6iwMeta } from "/codebuild/output/src797466349/src/src/pages/card/index.vue?macro=true";
import { default as _91id_939tk_45Y86ScS1TseuexsDTkyP_45PRJ_n3bYhX2La0_pVpAMeta } from "/codebuild/output/src797466349/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancewkv6xqe9zPH3cqsUT_HwfWTgC34JcIe_45GxAyNomC3Z8Meta } from "/codebuild/output/src797466349/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_937dZrwU41Zkqt58SGh1ROBnYTiJ5sx4CRJb9HO1Lw1_QMeta } from "/codebuild/output/src797466349/src/src/pages/notice/[id].vue?macro=true";
import { default as indexNDGbls9OQh3N66FwTE2b7kRcz9CC3_2EH9IZNG2YmCoMeta } from "/codebuild/output/src797466349/src/src/pages/coupon/index.vue?macro=true";
import { default as indexcnVamd_SnxQdfLYLk1_cEeLVKMmfAmk4hwLcLbjyxAcMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/index.vue?macro=true";
import { default as indexCFPe1zWaMjsmmS_45Pc6wcGtpnnw_45BEkCbJls2UnAB9esMeta } from "/codebuild/output/src797466349/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93h2dHt2TlL9gjlX7Hf3XZakOGKbYOcJAH62XjnlLIqx0Meta } from "/codebuild/output/src797466349/src/src/pages/parking/[id].vue?macro=true";
import { default as indexHnxwkmAMxO5vGe8FXwSpuQc1J3BXlrF6V66wKGw9FS0Meta } from "/codebuild/output/src797466349/src/src/pages/history/index.vue?macro=true";
import { default as indextThL2Yhbrq69DC4VhjIG5zMZc1dPvivAeTVYTM1__jcMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/index.vue?macro=true";
import { default as indexh7A234MS8uig_c8_wFvKoFkqheuJ8XaON0hRVjA7rLgMeta } from "/codebuild/output/src797466349/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexOLfv_2_45NsGQSmcYXLZT4yy8_45QGSAykQcG6J8v7XV_4540Meta } from "/codebuild/output/src797466349/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviPDJWULZ710NJ6wVCURj80c2de9nGjUur43oaWz_xAtkMeta } from "/codebuild/output/src797466349/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editrEqxnoF91ALNaquqGPkZR_45GzJ8zIm_45wrKdgmwsFOTtEMeta } from "/codebuild/output/src797466349/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementa1KPe5bBQltcKpi6jaPE4x_45w6mAOeucJNDAr77xen8YMeta } from "/codebuild/output/src797466349/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexfcLyWY_YfRrz5EJ_45OJnm6ixYHQnv2XIqTTdied4tvA8Meta } from "/codebuild/output/src797466349/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dRBi6gspEbCUUjWBJ0P_45fe7h_zHiy4M_qzeSnSSMPFWMMeta } from "/codebuild/output/src797466349/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmmbF_45_1iOUXJ5cVPZXPUbpc5V49iO46VLZlSBtoPGWFIMeta } from "/codebuild/output/src797466349/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexQz_2UWIvOX9l06Fvdonn0imGcrqYvz1G6TI0kpxLvaAMeta } from "/codebuild/output/src797466349/src/src/pages/card/create/index.vue?macro=true";
import { default as indexgqTtVcCTdi9b53PSju0aLFnrSp6hr5m49YXThY9GB3IMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmMKcVK8Ow9qf9bKE08A8sTKVI6IyEzKclAF7ArGJroxAMeta } from "/codebuild/output/src797466349/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmbOojz3BRHplF2NNCd73V4CBUlWgvCeMEFMd3Y08UkDMMeta } from "/codebuild/output/src797466349/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeWBI6hmH4AiQHZ7Obbcxq8JpRn8fALDpDxn9HC8tQL8gMeta } from "/codebuild/output/src797466349/src/src/pages/membership/complete.vue?macro=true";
import { default as register2EnncuXwr8LzDebJ2XSsrP3XV7Ugz4Jt9e7_lZaOVTEMeta } from "/codebuild/output/src797466349/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93EHKhLIdc0pRl_45xPqxIyC9Okc55E3ehnLpElhMlovqN0Meta } from "/codebuild/output/src797466349/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm_hVE57W3YriqsO69LqR3ci0sMAnPuV88a_45farjkaWJIMeta } from "/codebuild/output/src797466349/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93b2Myrk6esaJ7aBmUGFd5IIxZRE1Kc0NODfUrWlknEg0Meta } from "/codebuild/output/src797466349/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexr0Ln4lM033bKbj6SuI6NCsYuA_45jcCOfdIT1oI2xqIUIMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeP1ml8j6Q9q8kiWCb7OaEZzQKagrDJphdRtvurSReKBgMeta } from "/codebuild/output/src797466349/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeDgz1VPIdhsQnovvz2Bvu1M6IhTmMDQ_45XashLwb3X5EAMeta } from "/codebuild/output/src797466349/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completenUVJm3LfHPOUGBhoQZl29c40oJLVQ9ENEWQdynhJA4kMeta } from "/codebuild/output/src797466349/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registertBm5wmcVK6H6EqvpCugWoLo8kSLKlVh2dxQAliumsvMMeta } from "/codebuild/output/src797466349/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete7NN9wjlb_EtWsoNZNq6KpqC5jwDrJ5l1RalAWFaEqmUMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexD5P8DyTPDvk1uhWnnw82mH_45gh3TiXL_45x3VltKto_45svsMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmPXYnJ_45mjoRpRrsbCb32URfO0jzuHbBGER6eYjejN1fwMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completepL4nraM_45pYMSEu6RBFl8BZCZyCdzSWTHbmiVt6DQ2FwMeta } from "/codebuild/output/src797466349/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index9NDvPZU9j1Z_JTATf87gIb6l2p4ISAN6jEPM_Qqu2uoMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93170RN3AazW_btVMWl3_0CX8RJnDuA7JGRtrCUM5VNv8Meta } from "/codebuild/output/src797466349/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completenD_ZxZqPo77rrj5Gq881vW8WcrXsExfJ3Y4pXoAp4ioMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias42bXBKOAx2kCZ6TmXiwIJBY5b8HRY8NWAGBxozLKLtgMeta } from "/codebuild/output/src797466349/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample7lJ0_45fgEPOye9dqehP4X6zNh2o9226aNkqsYH8NpD4wMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailqpu5Mt87N0FigsDINlaosh6I8eXU7SBhq1jHZA_45B1tMMeta } from "/codebuild/output/src797466349/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmI6_nYwdWmBmGdWKT07gyXyr7Li7S_45wJTAWmuUerhoJEMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentdayc7P8RpNgtBSW6rlYJ5z_45FsiW0kdjVto1Yc88IcDsMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmbDoODvtOIqUtPyfjH1_457Yq1kWSVfu2RxcHqfbh5girUMeta } from "/codebuild/output/src797466349/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateFaE5DXlfQD7n_45KM3zrK4FyrjrjezKgr_nJDZhsgsDXcMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeTVIJ_cECMr29Wtijy9rG_3kUN2_aVV_45nZvYj22UlChIMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeizHtrPLnyD_45dgOAWgFJw5MtTrXR6MvXjtB0_IzpgFNcMeta } from "/codebuild/output/src797466349/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passworddAXZegEfw5MY8erBDoHzAa2_45j6tmOZedywfFA7QDye4Meta } from "/codebuild/output/src797466349/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasu_jI_45mfVW_45KsBlAS8pTnHlysUR2hvXP2PvVJk2kGp_EMeta } from "/codebuild/output/src797466349/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registersYPyOeE8_454jhQR8w8alZ3PI3Xp8w9BbrKnYR9Qop7mwMeta } from "/codebuild/output/src797466349/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codenfdtVC_qDiEitJ9zLC1r6XzpoX6l1cXQq3KqLEsrnSYMeta } from "/codebuild/output/src797466349/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index2fWENGkTEjFP_sbFo_45lrYpQiDQVwmJEuNm8mboAEp1AMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4bDqHGdxSg56UjXuIHWWfjjoaxdf7FDgL1LPDysep6AMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexx6oM_nYJxKYhwPyUCwX8uFGNX89_uNlypb0RkWvEGSAMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexeyi_I6K_BwLTwaJ4SpEq7F3jVlqEuXJZW2xmH0wmHQQMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateEZ_tshDParK5vtx5UXdjoxbwxzvh7pSAcxs3ry2t0ZcMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeFB5u_qsnJy6j1RMjgLaq4B2xByWzQz3wgpg9VtvF_tsMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmHVvG_45yHWL3IwDIXD4LLoBnF9S79fBJxI7yXUxvbUInUMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexoIGaJZgl3BkcGUlfpvIRRuO_uWJtzvVKsg7kEV_UKQsMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeURHbcPynFlwyw0WHtGUE7QXENdRWa6HSYg_45gaK9THEwMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatevzIIwxZ4XZUnB6_45sVKEhZC2X4KRvJzPK0aLbv0mDLJIMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index2nNvjsvHSTXI3klnjiIX1z3rYNEFeO93Z6cWwn8bYmIMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexgomceUP324_uQGq1JO8s1jtrpsWCy4bw_45Y9ZcywBfnUMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completevdhdRLPUwxnP_4Pqi1M9ZW8ophG2g3k9E_45YgTpqJWWYMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index2r_45KMt53cD6flDDEcTQlFgACuKtJRwI1SKm9d64OPFgMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeoYJa55DsunO_1Gm_UcENRagNLd5VUmozkspNBejwCxsMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index7vJ3InEV1PbMAWSPXY_GIk6BJjLjMNLhe9zgHRV5CSAMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index5UDK5x9sN_45IkRMSl75BSjXG0XGInwVLc34P9nN6Pe5EMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexnUgibqhi8sSVSg7078GQ_45t5STusUS_45byp9ku7JUNOpEMeta } from "/codebuild/output/src797466349/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateV9XKdBm5Ctk4CCXoZ4tUn48scSj3XCKRbC8cQ0VeMqwMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmjgfQADcPuOM3ONeb4ShTUMA7Lc2BHZgwiyVxwabjqHcMeta } from "/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src797466349/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuHBflX3pewFZ8_IASfF2CKIFv8J_45ZNA5Bq1XGiazjd0QMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexl1mVl8I7wryahIvd76XxuJCq_458XY_SWiVebgF6H3DGQMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src797466349/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src797466349/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src797466349/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src797466349/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src797466349/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexNDGbls9OQh3N66FwTE2b7kRcz9CC3_2EH9IZNG2YmCoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexHnxwkmAMxO5vGe8FXwSpuQc1J3BXlrF6V66wKGw9FS0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexh7A234MS8uig_c8_wFvKoFkqheuJ8XaON0hRVjA7rLgMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexOLfv_2_45NsGQSmcYXLZT4yy8_45QGSAykQcG6J8v7XV_4540Meta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src797466349/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src797466349/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexQz_2UWIvOX9l06Fvdonn0imGcrqYvz1G6TI0kpxLvaAMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmMKcVK8Ow9qf9bKE08A8sTKVI6IyEzKclAF7ArGJroxAMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmbOojz3BRHplF2NNCd73V4CBUlWgvCeMEFMd3Y08UkDMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeWBI6hmH4AiQHZ7Obbcxq8JpRn8fALDpDxn9HC8tQL8gMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register2EnncuXwr8LzDebJ2XSsrP3XV7Ugz4Jt9e7_lZaOVTEMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm_hVE57W3YriqsO69LqR3ci0sMAnPuV88a_45farjkaWJIMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeP1ml8j6Q9q8kiWCb7OaEZzQKagrDJphdRtvurSReKBgMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeDgz1VPIdhsQnovvz2Bvu1M6IhTmMDQ_45XashLwb3X5EAMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completenUVJm3LfHPOUGBhoQZl29c40oJLVQ9ENEWQdynhJA4kMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registertBm5wmcVK6H6EqvpCugWoLo8kSLKlVh2dxQAliumsvMMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmPXYnJ_45mjoRpRrsbCb32URfO0jzuHbBGER6eYjejN1fwMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completepL4nraM_45pYMSEu6RBFl8BZCZyCdzSWTHbmiVt6DQ2FwMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index9NDvPZU9j1Z_JTATf87gIb6l2p4ISAN6jEPM_Qqu2uoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completenD_ZxZqPo77rrj5Gq881vW8WcrXsExfJ3Y4pXoAp4ioMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample7lJ0_45fgEPOye9dqehP4X6zNh2o9226aNkqsYH8NpD4wMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailqpu5Mt87N0FigsDINlaosh6I8eXU7SBhq1jHZA_45B1tMMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmI6_nYwdWmBmGdWKT07gyXyr7Li7S_45wJTAWmuUerhoJEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentdayc7P8RpNgtBSW6rlYJ5z_45FsiW0kdjVto1Yc88IcDsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmbDoODvtOIqUtPyfjH1_457Yq1kWSVfu2RxcHqfbh5girUMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeTVIJ_cECMr29Wtijy9rG_3kUN2_aVV_45nZvYj22UlChIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeizHtrPLnyD_45dgOAWgFJw5MtTrXR6MvXjtB0_IzpgFNcMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passworddAXZegEfw5MY8erBDoHzAa2_45j6tmOZedywfFA7QDye4Meta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src797466349/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registersYPyOeE8_454jhQR8w8alZ3PI3Xp8w9BbrKnYR9Qop7mwMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codenfdtVC_qDiEitJ9zLC1r6XzpoX6l1cXQq3KqLEsrnSYMeta || {},
    component: () => import("/codebuild/output/src797466349/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src797466349/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src797466349/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]